<div class="row ng-scope">
  <div class="col-12">

    <div class="row form-group">
      <label class="control-label col-2">Tên học sinh<span class="cred">(*)</span></label>
      <div class="col-6 in-place">
        <input type="text" tabIndex="1" disabled="disabled" class="form-control" placeholder="" [(ngModel)]="doituongSelect.HoVaTen">
        <button class="k-icon-modifier" (click)="ChonHocVien()">Chọn</button>
      </div>
      <div class="col-4">
        <div class="checkbox c-checkbox">
          <label>
            <input tabIndex="2" type="checkbox" [(ngModel)]="doituongSelect.DiemDanh" />
            <span class="fa fa-check"></span> {{'Điểm danh' | translate}}
          </label>
        </div>
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-2">{{'Đơn vị' | translate}}</label>
      <div class="col-4">
        <ng-select #slChiNhanh2
                   class="twcollong"
                   [tabIndex]="3"
                   [openOnEnter]="false"
                   [items]="dschinhanhs"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                   [(ngModel)]="doituongSelect.DonViId">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
      <label class="control-label col-2">{{'Giáo viên' | translate}}</label>
      <div class="col-4">
        <ng-select #slPhuTrach
                   class="twcollong"
                   [tabIndex]="4"
                   [openOnEnter]="false"
                   [items]="inputGiangViens"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="doituongSelect.GiaoVienId">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell rTableCell-1">{{item.Ma}}</div>
              <div class="rTableCell rTableCell-2">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>

    </div>

    <div class="row form-group">
      <label class="control-label col-2">Ngày kiểm tra<span class="cred">(*)</span></label>
      <div class="col-2">
        <kendo-dateinput tabindex="5" style="width:138px !important;" [format]="'dd/MM/yyyy'" [(value)]="doituongSelect.NgayKiemTra"></kendo-dateinput>
      </div>
      <div class="col-2">
        <kendo-dateinput tabindex="6" style="width:80px;" [format]="'HH:mm'" [(value)]="doituongSelect.NgayKiemTra"></kendo-dateinput>
      </div>

    </div>
    <div class="row form-group">
      <label class="control-label col-2">{{'Tình hình' | translate}}</label>
      <div class="col-4">
        <textarea type="text" tabIndex="7" rows="2" class="form-control" placeholder="" [(ngModel)]="doituongSelect.TinhHinh"></textarea>
      </div>
      <label class="control-label col-2">{{'Ghi chú' | translate}}</label>
      <div class="col-4">
        <textarea type="text" tabIndex="8" rows="2" class="form-control" placeholder="" [(ngModel)]="doituongSelect.GhiChu"></textarea>
      </div>
    </div>
   


    <div class="row form-group">
      <label class="control-label col-2">{{'Kết quả' | translate}}</label>
      <div class="col-10">
        <ejs-richtexteditor style="background-color:white" height='150px' #toolsRTE id='alltoolRTE_ch' [toolbarSettings]='tools' [showCharCount]='true' [(value)]='doituongSelect.KetQua'
                            [maxLength]='maxLength' [fileManagerSettings]='fileManagerSettings' [quickToolbarSettings]='quickToolbarSettings'
                            (actionBegin)='handleFullScreen($event)' (actionComplete)='actionCompleteHandler($event)'>
        </ejs-richtexteditor>
      </div>
    </div>


    <div class="row form-group">
      <label class="control-label col-2">Hướng lớp</label>
      <div class="col-4 in-place">
        <input type="text" tabIndex="11" class="form-control" placeholder="" [(ngModel)]="doituongSelect.TenLop">
        <button class="k-icon-modifier" (click)="ChonLopHoc()">Chọn</button>
      </div>
      <label class="col-xl-2 col-form-label">{{'Trạng thái' | translate}} </label>
      <div class="col-4">
        <ng-select [openOnEnter]="false"
                   [items]="inputtrangthais"
                   bindValue="Id"
                   bindLabel="Ten"
                   tabindex="12"
                   notFoundText="Không có dữ liệu"
                   placeholder=""
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="doituongSelect.TrangThai">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>


    </div>

    <div class="row form-group">
      <label class="col-xl-2 col-form-label">{{'Ngày tạo' | translate}}</label>
      <div class="col-xl-4">
        <span>{{doituongSelect.Created | date: 'dd/MM/yyyy HH:mm:ss'}}</span>
      </div>
      <label class="col-xl-2 col-form-label">{{'Người tạo' | translate}}</label>
      <div class="col-xl-4">
        <span>{{doituongSelect.CreatedBy}}</span>
      </div>
    </div>
    <div class="row form-group">
      <label class="col-xl-2 col-form-label">{{'Ngày sửa' | translate}}</label>
      <div class="col-xl-4">
        <span>{{doituongSelect.Modified | date: 'dd/MM/yyyy HH:mm:ss'}}</span>
      </div>
      <label class="col-xl-2 col-form-label">{{'Người sửa' | translate}}</label>
      <div class="col-xl-4">
        <span>{{doituongSelect.ModifiedBy}}</span>
      </div>
    </div>





    <!--<div class="clearfix"></div>
    <div class="row">
      <div class="col-3">
        <div class="sample-container">
          <div id='uploadFileManager' class="fileupload" style="margin-top:1px">
            <ejs-uploader #uploadObj id='defaultfileupload'></ejs-uploader>
            <button ejs-button id='openBtn' (click)="btnClick()">{{'Ảnh đại diện' | translate}}</button>
          </div>

        </div>
      </div>
      <div class="col-9">
        <div class="row" style="margin-top:50px;margin-left:5px">
          <div class="col-md-12">
            {{doituongSelect.DuongDanAnh}}
          </div>
          <div class="col-md-12" style="float:right">
            <a href="{{doituongSelect.DuongDanAnh}}" target="_blank" class="mr-1 btn btn-labeled btn-success mb-2" type="button"><i class="fa fas fa-download"></i> {{'Tải xuống' | translate}}</a>
            <button (click)="deleteFile()" class="mr-1 btn btn-labeled btn-danger mb-2" type="button"><i class="fa fa-times"></i> {{'Xóa' | translate}}</button>
          </div>

        </div>
      </div>
    </div>-->




  </div>

</div>

<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div style="display:flex;">
    <!--<div class="checkbox c-checkbox">
      <label>
        <input tabIndex="20" type="checkbox" [(ngModel)]="doituongSelect.TrangThai" />
        <span class="fa fa-check"></span> {{'Hoạt động' | translate}}
      </label>
    </div>-->
  </div>

  <div class="">
    <button style="float:left !important" class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="">{{'Hủy bỏ' | translate}}</button>
    <button style="float:left !important" *ngIf="!(quyen_sua==false && doituongSelect.Id!=null)" type="submit" (click)="saveproduct()" title="" class="mb-1 mr-1 btn btn-primary">{{'Lưu lại' | translate}}</button>
  </div>

</div>


<div id='target' class="control-section">
  <ejs-dialog #dialogObj id='dialog' [visible]='visible' [header]='dialogHeader' [animationSettings]='animationSettings' [showCloseIcon]='showCloseIcon' (open)="dialogOpen()" (close)="dialogClose()"
              [target]='target' [width]='dialogWidth'>
    <ejs-filemanager #filemanagerObj id='filemanager' (beforeSend)="OnbeforeSend($event)"
                     [ajaxSettings]='ajaxSettings' [toolbarSettings]='toolbarSettings'
                     [contextMenuSettings]='contextMenuSettings'
                     [allowMultiSelection]='false' (fileOpen)="onFileOpen($event)" [showThumbnail]="false">
    </ejs-filemanager>
  </ejs-dialog>
</div>


<bs-modal #mdChonLopHoc class="modal fade show in" [cssClass]="'modal800'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Chọn lớp học</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdChonLopHoc.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-tonghop-chonlophocedit #chonlophocedit (save)="saveModal_LopHoc($event)"></app-tonghop-chonlophocedit>
  </bs-modal-body>
</bs-modal>

<bs-modal #mdChonHocVien class="modal fade show in" [cssClass]="'modal800'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Chọn học sinh</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdChonHocVien.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-tonghop-chonhocvientiemnangedit #chonhocvienedit (save)="saveModal($event)"></app-tonghop-chonhocvientiemnangedit>
  </bs-modal-body>
</bs-modal>
